export const DARK_THEME = 'dark';
export const LIGHT_THEME = 'light';

export const VARIANT_STATIC = 'static';
export const VARIANT_OVERLAY = 'overlay';
